module.exports = __webpack_public_path__ + "static/media/brand1.94261a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/brand1.png
// module id = 530
// module chunks = 0